import BaseItems from "../../../components/contracts/BaseItems";
import { NavItemClassEnum } from "../../../strings/TabRouterStrings";
import { LayoutRouteUsage } from "../../../redux/types";
import { LocalShipping } from "@material-ui/icons";
import ContractItemContainer from "../services/ContractItemContainer";
import Baseservicepackage from "../../../components/contracts/servicepackages/Baseservicepackage";

const ServicePackagesRouter: LayoutRouteUsage = (t) => [
  {
    apiUsage: ["contracts/baseservicepackages"],
    requireSuperuser: true,
    routes: [
      {
        path: "/contracts/baseservicepackages",
        label: t("contractNavbarBaseServicepackagesLabel"),
        component: BaseItems,
        subTabIndex: 2,
        highlightClass: NavItemClassEnum.SERVICESANDPRODUCTS,
        icon: LocalShipping
      },
      {
        path: "/contracts/baseservicepackages/:baseServicepackageId",
        parent: "/contracts/baseservicepackages",
        label: t("baseServicePackageLabel"),
        component: Baseservicepackage,
        highlightClass: NavItemClassEnum.SERVICESANDPRODUCTS
      },
      {
        path: "/contracts/:contractId/servicepackages/:contractItemId",
        parent: "/contracts/servicepackages",
        label: t("servicePackageLabel"),
        component: ContractItemContainer,
        highlightClass: NavItemClassEnum.SERVICESANDPRODUCTS
      },
      {
        path: "/contracts/baseitems",
        label: t("baseItemsLabel"),
        component: BaseItems,
        highlightClass: NavItemClassEnum.SERVICESANDPRODUCTS
      }
    ]
  }
];

export default ServicePackagesRouter;
